import { Alert, Form, Input } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import '../Copywriting.scss';

export const Tagline = () => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const taglineValue = Form.useWatch('tagline', form);

  return (
    <FormLineLayout
      label="Tagline"
      labelOnTop
      rightClassName="copywriting-form"
    >
      <div className="tagline-wrapper">
        <Form.Item name="tagline">
          {isEditMode ? (
            <Input.TextArea rows={2} />
          ) : (
            <span className="view-data">
              {taglineValue ? taglineValue : 'ø empty'}
            </span>
          )}
        </Form.Item>
        {isEditMode && (
          <Alert
            message="The tagline will appear as a preview of the description. It should be concise and explain the experience in a few words."
            type="info"
            showIcon
          />
        )}
      </div>
    </FormLineLayout>
  );
};
